import { render, staticRenderFns } from "./EducationPage.vue?vue&type=template&id=02c7ed86&scoped=true&"
import script from "./EducationPage.vue?vue&type=script&lang=js&"
export * from "./EducationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c7ed86",
  null
  
)

export default component.exports